import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';

export const AuditLogEvent: ITypeSpecificPolicy<types.AuditLogEvent> = {
  fields: {
    createdTimestamp: dateTimeFieldPolicy()
  }
};
